import axios from 'axios';
import { format } from 'date-fns';

import { TeamRosterResponseData } from './types';
import { Interval, PlanUnitMix } from 'components/types';

import { getPlanunitCommaIds } from 'components/utils';

import { TEAM_ROSTER } from 'RestAPIs/endpoints';

export const getTeamRosterData = (
  interval: Interval,
  selectedPlanUnits: PlanUnitMix[],
  includeDutiesFromDifferentCostCenters: boolean
) => {
  const params: any = {
    startDate: format(interval.startDate, 'yyyy-MM-dd'),
    endDate: format(interval.endDate, 'yyyy-MM-dd'),
    includeDutiesFromDifferentCostCenters: includeDutiesFromDifferentCostCenters
  };

  if (selectedPlanUnits.length) {
    params.costCenterIds = getPlanunitCommaIds(selectedPlanUnits);
  }

  return axios.get<TeamRosterResponseData>(TEAM_ROSTER, {
    params
  });
};
